export default __webpack_public_path__ + "static/media/avatar.3aca98dd.jpg";